"use client";

import { useTranslations } from "next-intl";
import { type ReactElement, useState } from "react";

const CONTACT_EMAIL_CODES: readonly number[] = [
  107, 111, 110, 116, 97, 107, 116, 64, 104, 97, 117, 115, 118, 101, 114, 119,
  97, 108, 116, 101, 114, 46, 97, 105,
];

function buildContactText(): string {
  const atLabel = ["a", "t"].join("");
  return String.fromCharCode(...CONTACT_EMAIL_CODES).replace(
    String.fromCharCode(64),
    ` [${atLabel}] `,
  );
}

export function ContactEmailReveal(): ReactElement {
  const t = useTranslations("public.contactEmailReveal");
  const [revealed, setRevealed] = useState(false);

  if (revealed) {
    return (
      <span className="font-medium text-primary/85" aria-live="polite">
        {buildContactText()}
      </span>
    );
  }

  return (
    <button
      type="button"
      className="inline-flex h-7 items-center rounded-md border border-primary/10 bg-secondary/40 px-2.5 text-[12px] font-medium text-primary/70 transition-colors hover:bg-secondary/70 hover:text-primary/90 focus:outline-none focus:ring-2 focus:ring-action-500/20"
      onClick={() => setRevealed(true)}
    >
      {t("eMailAnzeigen")}
    </button>
  );
}
